import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import translations from '../../translations';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import { injectStripe } from 'react-stripe-elements';
import StripeIdealBankField from '../../../StripeComponents/StripeIdealBankField';
import useIntl from '@afosto/utils-react/intl/useIntl';
import FormActions from '@afosto/app-components-react/Form/FormActions';
import TextField from '@afosto/app-components-react/TextField';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import createIdealSource from '../../../../utils/stripe/createIdealSource';

const InjectedIdealField = injectStripe(StripeIdealBankField, { withRef: true });

const IdealBankSelect = ({ stripe, innerRef, setFormStep }) => {
  const intl = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorState, setErrorState] = useState({
    formError: null,
    cardNumberError: null,
    expiredError: null,
    cvcError: null,
  });

  const handleCreateIdealSource = async event => {
    setIsSubmitting(true);
    event.preventDefault();

    try {
      const { source = {} } = await createIdealSource(stripe);
      const { redirect } = source;
      const { url } = redirect;

      window.location.href = url;

      return url;
    } catch (error) {
      setIsSubmitting(false);
      return Promise.reject(error);
    }
  };

  const handleChange = fieldError => ({ error = { message: null } }) => {
    setErrorState({ ...errorState, [fieldError]: error.message });
  };

  const { idealError } = errorState;

  return (
    <form noValidate onSubmit={handleCreateIdealSource} autoComplete="off">
      <LoadingWrapper isLoading={isSubmitting}>
        <Typography variant="h6" component="div" gutterBottom>
          <FormattedMessage {...translations.options.iDeal.steps.bankSelect.title} />
        </Typography>
        <TextField
          readOnly
          value="€ 0,01"
          variant="outlined"
          fullWidth
          label={intl.formatMessage(translations.fields.amount.label)}
        />
        <InjectedIdealField
          onChange={handleChange('idealError')}
          error={!!errorState.idealError}
          helperText={idealError}
          stripe={stripe}
          ref={innerRef}
          label={intl.formatMessage(translations.fields.bank.label)}
          disabled={isSubmitting}
        />
        <FormActions>
          <Button type="submit" color="primary" variant="contained" disabled={isSubmitting}>
            <FormattedMessage {...translations.formActions.confirm} />
          </Button>
          <Button onClick={() => setFormStep(1)} variant="outlined">
            <FormattedMessage {...translations.formActions.back} />
          </Button>
        </FormActions>
      </LoadingWrapper>
    </form>
  );
};

IdealBankSelect.propTypes = {
  stripe: PropTypes.object,
  innerRef: PropTypes.shape({ current: PropTypes.any }),
  setFormStep: PropTypes.func,
};

IdealBankSelect.defaultProps = {
  stripe: undefined,
  innerRef: undefined,
  setFormStep: undefined,
};

export default IdealBankSelect;
